import runningPlatform from './runningPlatform';

export const platform = {
  web: runningPlatform === 'web',
  ios: runningPlatform === 'ios',
  android: runningPlatform === 'android',
};

export const platformSwitch = ({ web, ios = null, android = null, native = null }) => {
  if (native) return platform.web ? web : native;

  const mobile = platform.android ? android : ios;
  
  return platform.web ? web : mobile;
};
